<template>
	<div class="msg-analysis-program" v-if="!isError">
		<div class="msg-analysis-program-title">
			<img :src="message.iconUrl" alt="">
			<span>{{message.nickname}}</span>
		</div>
		<div class="msg-analysis-program-desc">{{message.title}}</div>
		<div class="msg-analysis-program-big">
			<img :src="message.hDj" alt="">
		</div>
		<div class="msg-analysis-program-footer">
			<span class="msg-analysis-program-link"></span>
			<span>小程序</span>
		</div>
	</div>
	<div class="msg-analysis-program-error" v-else>
		小程序消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisProgram',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: {},
				isError: false
			}
		},
		methods:{
			format(){
				try {
					let message = JSON.parse(this.msg.content)
					if(message.hDj === undefined){
						message.hDj = message.iconUrl.replace("/96","/0")
					}
					this.message = message
				}catch (e) {
					this.isError = true
				}
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-program-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-program {
		width: 220px;
		height: auto;
		background-color: #ffffff;
		cursor: pointer;
		border: 1px solid #e7e7e7;
		border-radius: 4px;
	}
	.msg-analysis-program .msg-analysis-program-title{
		height: 20px;
		padding: 5px;
		font-size: 12px;
		color: #999999;
	}
	.msg-analysis-program-title > *{
		display: inline-block;
		height: 20px;
		line-height: 20px;
		vertical-align: middle;
	}
	.msg-analysis-program-title img{
		width: 20px;
		border-radius: 10px;
	}
	.msg-analysis-program-title span{
		margin-left: 5px;
		width: 125px;
		overflow: hidden;
		font-size: 12px;
	}
	.msg-analysis-program-desc{
		line-height: 20px;
		height: 20px;
		overflow: hidden;
		padding: 0 5px;
		margin-bottom: 5px;
	}
	.msg-analysis-program-big{
		width: 100%;
		padding: 0 5px 5px 5px;
		box-sizing: border-box;
	}
	.msg-analysis-program-big > img{
		width: 100%;
		height: auto;
	}
	.msg-analysis-program-footer{
		border-top: 1px solid #e2e2e2;
		color: #999999;
		font-size: 12px;
		padding: 2px 5px;
	}
	.msg-analysis-program-footer span{
		display: inline-block;
		height: 16px;
		line-height: 16px;
		vertical-align: middle;
	}
	.msg-analysis-program-footer .msg-analysis-program-link{
		width: 16px;
		background-image: url(/img/link2.png);
		background-size: 15px 15px;
		background-repeat: no-repeat;
		background-position: center;
		margin-right: 5px;
	}
</style>
